<!-- LEYENDA DE LOS COMENTARIOS

    [...] ->  Palabra dentro de [] hace referencia a una variable o referencia textual del código. Al usar Ctrl + F (sin los []) sobre este te saldrán todas las incidencias.

    [!]   ->  Información importante favor de leer.

    [~]   ->  Pendiente por trabajar o no funciona correctamenta pero no es urgente.

    [?]   ->  Duda del funcionamiento.

    // >>   ->  Quiere decir que las variables o métodos que tengan esta leyenda en su símbolo forman parte del comentario anterior.
                Por ejemplo: [ORIGINAL DATA DETALLE KPI] forma parte de [DETALLE DE KPI].
    
    NOTA: Todos los "elementos" del [template] tienen un título comentado por lo que al colapsar el [tag] debajo del título podrá visualizar mejor el código.
 -->
<template>
  <div>
    <!-- FILTROS Y BOTÓN DE AGREGAR -->
    <rabbey-toolbox :call-new="AddNewGerencia">
      <!-- FILTRO POR GERENCIA -->
      <!--       
      <el-select
        v-if="isCEO"
        v-model="directionName"
        filterable
        clearable
        size="medium"
        placeholder="Direccion"
        width="200"
        style="margin-right: 10px"
        @change="handleDirectionChange"
      >
        <el-option
          v-for="(direction, index) in directions"
          :key="index"
          :label="direction.label"
          :value="direction"
        ></el-option>
      </el-select>
       -->

      <!-- [~]  -->
      <!-- <el-select
        v-model="responsableFilter"
        filterable
        clearable
        size="medium"
        placeholder="Responsable"
        style="margin-right: 10px"
        @change="handleResponsableFilter"
      >
        <el-option
          v-for="responsables in responsablesList"
          :key="responsables.EmployeeID"
          :label="responsables.Name"
          :value="responsables.EmployeeID"
        >
        </el-option>
      </el-select> -->

      <!-- FILTRO POR AÑO -->
      <el-select
        v-model="year"
        size="medium"
        placeholder="Año"
        width="200"
        style="margin-right: 10px"
        @change="handleYearChange"
      >
        <el-option
          v-for="(year, index) in yearsForFilter"
          :key="index"
          :label="year.label"
          :value="year.value"
        ></el-option>
      </el-select>
    </rabbey-toolbox>

    <!-- Tabla de Prueba -->
    <!--     
    <el-table
      :data="Childs"
      style="width: 100%; margin-bottom: 20px"
      row-key="countID"
    >
      <el-table-column
        minWidth="80"
        fixed
        align="center"
        v-if="ExpandTree !== undefined"
      >

      </el-table-column>
      <el-table-column
        width="50"
        fixed
        align="center"
        v-if="actions !== undefined"
      >
        <template slot="header" slot-scope="scope">
          <i class="el-icon-setting" :key="scope.$index"></i>
        </template>
        <template slot-scope="scope">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="mdi mdi-menu"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <template v-for="(action, index) in actions">
                <el-dropdown-item
                  v-if="
                    action.condition !== undefined &&
                    typeof action.condition === 'function'
                      ? action.condition(scope.row)
                      : true
                  "
                  :key="index"
                  :command="{
                    index: scope.$index,
                    row: scope.row,
                    column: scope.column,
                    command: action.command
                  }"
                  :icon="action.icon"
                  >{{ action.label }}</el-dropdown-item
                >
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <el-table-column
        v-for="(column, index) in column"
        :key="index"
        :formatter="
          typeof column.formatter === 'function' ? column.formatter : null
        "
        v-bind="column"
      >
        <template
          v-if="typeof column.formatter !== 'function'"
          #default="scope"
        >
          {{ /* Enter here only if formatter is not a function if it is let element take care of it. */ }}
          {{ /* If you enter it means that formatter is not a function but it can still be a Vue Component */ }}
          {{ /* therefore it validates if it is a component, otherwise it renders its value. */ }}
          <template
            v-if="
              column.formatter !== undefined &&
              Object.keys(column.formatter).length > 0 &&
              Object.keys(column.formatter).includes('name')
            "
          >
            <div
              :is="column.formatter"
              v-bind="{
                row: scope.row,
                column: column.prop,
                rowValue: arrayGet(scope.row, column.prop),
                ...column.cellAtrrs, // this field must be removed in the next version and use only attrs
                ...column.attrs
              }"
            ></div>
          </template>
          <template v-else>
            {{ arrayGet(scope.row, column.prop) }}
          </template>
        </template>
      </el-table-column>
     
    </el-table> 
    -->

    <!-- TABLA PRINCIPAL -->
    <!-- tableData -->
    <!-- :data="showAllData ? tableData : filteredTableData" -->
    <!-- filteredTableData -->
    <!-- :ExpandColumnTreeWith="500" -->

    <rabbey-table-3
      :loading="loadingTable"
      :data="Childs"
      row-key="countID"
      :border="true"
      :ExpandTree="true"
      ExpandColumnTreeAlign="left"
      :columns="column"
      :actions="actions"
      :row-class-name="tableRowClassName"
      @rtable-push-action="handlePushAction"
      :key="componentKey"
      ref="rabbeTable3"
    />
    <!--
    <rabbey-table-3
      :loading="loadingTable"
      :data="tableDataTree"
      row-key="id"
      :columns="column"
      :actions="actions"
      :row-class-name="tableRowClassName"
      @rtable-push-action="handlePushAction"
    />
    -->

    <!-- AGREGAR NUEVA GERENCIA -->
    <el-dialog
      title="Agregar Gerencia"
      width="20%"
      :visible.sync="showAddGerencia"
      :before-close="handleBeforeClose"
    >
      <el-form style="margin: 20px">
        <!-- DIRECTION SELECT -->
        <el-form-item label="Seleccione la Gerencia">
          <el-select
            v-model="createDirectionName"
            filterable
            clearable
            size="medium"
            placeholder="Direccion"
            width="200"
            @change="handleNewDirectionChange"
          >
            <el-option
              v-for="(direction, index) in directions"
              :key="index"
              :label="direction.label"
              :value="direction"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- RESPONSABLE SELECT -->
        <el-form-item label="Responsable de la Gerencia">
          <el-select
            v-loading="responsableLoading"
            v-model="employeeId"
            filterable
            clearable
            size="medium"
            placeholder="Colaborador"
            @change="handleChangeEmployee"
          >
            <el-option
              v-for="employee in directionEmployees"
              :key="employee.EmployeeID"
              :label="employee.Name"
              :value="employee.EmployeeID"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            size="mini"
            type="primary"
            :loading="buttonLoading"
            style="float: right"
            @click="addDirection"
          >
            Agregar
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- DETALLE DE KPI -->
    <el-dialog
      :visible="showAddKpi"
      title="Detalle de KPI"
      width="30%"
      :before-close="handleKpiBeforeClose"
      :close-on-click-modal="false"
    >
      <el-form label-position="top">
        <!-- SELECT GERENCIA Y AÑO -->
        <el-row :gutter="20">
          <el-col :span="12">
            <!-- [~] -->
            <el-form-item label="Gerencia">
              <el-select
                v-model="kpiDepartment"
                filterable
                clearable
                size="medium"
                placeholder="Direccion"
                width="200"
                disabled
                @change="handleNewDirectionChange"
              >
                <el-option
                  v-for="(direction, index) in directions"
                  :key="index"
                  :label="direction.label"
                  :value="direction"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Año: ">
              <el-input disabled v-model="year"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- SELECT RESPONSABLE y MODALIDAD -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="Responsable">
              <el-select
                v-loading="responsableLoading"
                v-model="responsableKpi"
                :disabled="
                  this.currentUser.IsSupervisor ? this.disableEdit : true
                "
                filterable
                clearable
                size="medium"
                placeholder="Responsable"
                @change="handleChangeEmployee"
              >
                <el-option
                  v-for="employee in directionEmployees"
                  :key="employee.EmployeeID"
                  :label="employee.Name"
                  :value="employee.EmployeeID"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Modalidad:">
              <el-select
                v-model="kpiType"
                size="medium"
                :disabled="
                  this.currentUser.IsSupervisor ? this.disableEdit : true
                "
                @change="handleKpiTypeChange"
              >
                <el-option
                  v-for="type in kpiTypes"
                  :key="type.Id"
                  :label="type.Description"
                  :value="type.Id"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="type.Meaning"
                    placement="right"
                  >
                    <span>{{ type.Description }}</span>
                  </el-tooltip>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item
          label="Fórmula Seleccionada: "
          v-if="selectedFormula && selectedFormula.Id > 0"
        >
          <el-input :disabled="true" v-model="selectedFormula.Name">
            <el-button
              slot="append"
              type="primary"
              style="color: white"
              @click="handleChangeFormula"
              ><i class="el-icon-edit"></i
            ></el-button>
          </el-input>
        </el-form-item>

        <el-form-item label="Nombre del KPI: ">
          <el-input
            type="textarea"
            :rows="2"
            :disabled="this.currentUser.IsSupervisor ? this.disableEdit : true"
            v-model="kpiName"
          ></el-input>
        </el-form-item>

        <!-- TABLA DE DETALLE -->
        <el-form-item>
          <rabbey-table3
            :data="detailData"
            :columns="detailColumns"
            style="margin-top: 30px"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            style="float: right"
            v-if="this.disableEdit == false"
            :loading="saveBtnLoading"
            @click="handleKpiDetailSave"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- ELIMINAR KPI -->
    <el-dialog
      :title="getDeleteDialogTitle"
      :visible.sync="showDeleteDialog"
      width="20%"
      center
    >
      <span
        v-if="deleteDepartmentOrKPI == 'delete-department'"
        style="margin-left: 45px"
        >¿Esta seguro de querer eliminar esta Gerencia?</span
      >
      <span
        v-if="deleteDepartmentOrKPI == 'delete-kpi'"
        style="margin-left: 30px"
        >¿Esta seguro de querer eliminar este KPI?</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDeleteDialog">Cancelar</el-button>
        <el-button type="danger" size="small" @click="deleteDepartmentOrKpi"
          >Si, Eliminar</el-button
        >
      </span>
    </el-dialog>

    <!-- TABLA DE SELECCIÓN DE FÓRMULA -->
    <el-dialog
      title="Seleccione la formula para automatizar KPI"
      width="50%"
      center
      :visible.sync="showKpiFormulaDialog"
      :before-close="handleCloseKpiFormulaDialog"
      :close-on-click-modal="false"
    >
      <h3>
        Nombre del KPI: <span>{{ this.kpiName }}</span>
      </h3>
      <rabbey-table-3
        :loading="kpiFormulaLoading"
        :data="kpiFormulaList"
        :columns="kpiFormulaColumns"
        highlight-current-row
        @current-change="handleSelectedFormula"
      />
    </el-dialog>
  </div>
</template>

<script>
import { formatArrayToElSelect } from "@/utils";
import InputFormatter from "@/components/functionals/InputColumn.vue";
import CashFlowHyperlink from "@/components/functionals/CashFlowHyperlink.vue";
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
import get from "lodash/get";
const arrayGet = get;

export default {
  name: "Kpi-Gerencial",
  data() {
    return {
      //DataTable de ejemplo para probar el tableTree
      /*
      tableDataTree: [
        {
          id: 1,
          date: "2016-05-02",
          Name: "wangxiaohu"
        },
        {
          id: 2,
          date: "2016-05-04",
          Name: "wangxiaohu"
        },
        {
          id: 3,
          date: "2016-05-01",
          Name: "wangxiaohu",
          children: [
            {
              id: 31,
              date: "2016-05-01",
              Name: "wangxiaohu"
            },
            {
              id: 32,
              date: "2016-06-01",
              Name: "wangxiaohu",
              children: [
                {
                  id: 41,
                  date: "2016-06-01",
                  Name: "wangxiaohu"
                },
                {
                  id: 42,
                  date: "2016-06-01",
                  Name: "wangxiaohu"
                }
              ]
            }
          ]
        },
        {
          id: 4,
          date: "2016-05-03",
          Name: "wangxiaohu"
        }
      ],
      */
      //"GLOBALES" (que se usan en más de un componente)
      directions: [],
      directionsChild: [],
      Childs: [],
      departmentsChild: [],
      EmployeesChild: [],
      employeeId: null,
      responsableLoading: false,

      //TABLA PRINCIPAL
      componentKey: 0,
      loadingTable: false,
      showAllData: true,
      tableData: [],
      filteredTableData: [],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver KPI",
          command: "show-kpi",
          condition: (row) => row.KpiId > 0
        },
        {
          icon: "el-icon-plus",
          label: "Agregar KPI",
          command: "add-kpi",
          condition: (row) =>
            (row.KpiId == 0 && this.currentUser.IsSupervisor) ||
            (row.KpiId == 0 && this.currentUser.UserID == 10)
        },
        {
          icon: "el-icon-edit",
          label: "Editar KPI",
          command: "edit-kpi",
          condition: (row) =>
            (row.KpiId > 0 &&
              this.currentUser.UserID == row.Responsable.UserID) ||
            (row.Responsable &&
              this.currentUser.EmployeeId == row.Responsable.SuperVisorID) ||
            (row.KpiId > 0 && this.currentUser.UserID == 10)
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar Gerencia",
          command: "delete-department",
          condition: (row) => row.KpiId == 0 && this.currentUser.IsSupervisor
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar KPI",
          command: "delete-kpi",
          condition: (row) =>
            (row.KpiId > 0 &&
              this.currentUser.IsSupervisor &&
              this.currentUser.UserID == row.Responsable.UserID) ||
            (row.Responsable &&
              this.currentUser.EmployeeId == row.Responsable.SuperVisorID) ||
            (row.KpiId > 0 && this.currentUser.UserID == 10)
        },
        {
          icon: "el-icon-refresh",
          label: "Actualizar KPI",
          command: "update-kpi",
          condition: (row) => row.KpiId > 0 && row.FormulaId
        }
      ],
      column: [
        {
          prop: "Name",
          label: "Gerencias>Departamentos>Responsables",
          minWidth: 300
        },
        {
          prop: "Responsable.FullName",
          label: "Responsable",
          minWidth: 300,
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "Responsable.imageUrl"
          }
        },
        {
          prop: "January",
          label: "Enero",
          minWidth: 100,
          formatter: CashFlowHyperlink,
          attrs: {
            percentFormat: true
          }
        },
        {
          prop: "February",
          label: "Febrero",
          minWidth: 100,
          formatter: CashFlowHyperlink,
          attrs: {
            percentFormat: true
          }
        },
        {
          prop: "March",
          label: "Marzo",
          minWidth: 100,
          formatter: CashFlowHyperlink,
          attrs: {
            percentFormat: true
          }
        },
        {
          prop: "April",
          label: "Abril",
          minWidth: 100,
          formatter: CashFlowHyperlink,
          attrs: {
            percentFormat: true
          }
        },
        {
          prop: "May",
          label: "Mayo",
          minWidth: 100,
          formatter: CashFlowHyperlink,
          attrs: {
            percentFormat: true
          }
        },
        {
          prop: "June",
          label: "Junio",
          minWidth: 100,
          formatter: CashFlowHyperlink,
          attrs: {
            percentFormat: true
          }
        },
        {
          prop: "July",
          label: "Julio",
          minWidth: 100,
          formatter: CashFlowHyperlink,
          attrs: {
            percentFormat: true
          }
        },
        {
          prop: "August",
          label: "Agosto",
          minWidth: 100,
          formatter: CashFlowHyperlink,
          attrs: {
            percentFormat: true
          }
        },
        {
          prop: "September",
          label: "Septiembre",
          minWidth: 100,
          formatter: CashFlowHyperlink,
          attrs: {
            percentFormat: true
          }
        },
        {
          prop: "October",
          label: "Octubre",
          minWidth: 100,
          formatter: CashFlowHyperlink,
          attrs: {
            percentFormat: true
          }
        },
        {
          prop: "November",
          label: "Noviembre",
          minWidth: 100,
          formatter: CashFlowHyperlink,
          attrs: {
            percentFormat: true
          }
        },
        {
          prop: "December",
          label: "Diciembre",
          minWidth: 100,
          formatter: CashFlowHyperlink,
          attrs: {
            percentFormat: true
          }
        }
      ],
      /*
      pagination: {
        //La paginación se hardcodea de esta forma para que se visualice todo en una sola pantalla.
        currentPage: 1,
        pageSize: 10000,
        total: this.getTotalofItems // [~] Esto no funciona adecuantamente.
      },
      */
      //FILTRO POR GERENCIA
      directionName: "",

      //FILTRO POR RESPONSABLE [~]
      responsableFilter: "",
      responsablesList: [],

      //FILTRO POR AÑOS
      year: new Date().getFullYear(),

      //AGREGAR NUEVA GERENCIA
      showAddGerencia: false,
      createDirectionName: "",
      directionId: null,
      directionResponsable: "",
      directionEmployees: [],
      buttonLoading: false,

      //DETALLE DE KPI
      responsableKpi: "",
      saveBtnLoading: false,
      showAddKpi: false,
      disableEdit: "",
      kpiType: 1,
      kpiDirection: 0,
      kpiId: 0,
      kpiMasterId: 0,
      kpiDepartment: "",
      kpiName: "",
      detailDataEdit: [],
      /*
      paginationApi: {
        currentPage: 1,
        pageSize: 12,
        total: 12
      },
      */
      detailData: [
        {
          month: "Enero",
          Jan_target: 0,
          Jan_getter: 0
        },
        {
          month: "Febrero",
          Feb_target: 0,
          Feb_getter: 0
        },
        {
          month: "Marzo",
          Mar_target: 0,
          Mar_getter: 0
        },
        {
          month: "Abril",
          Abr_target: 0,
          Abr_getter: 0
        },
        {
          month: "Mayo",
          May_target: 0,
          May_getter: 0
        },
        {
          month: "Junio",
          Jun_target: 0,
          Jun_getter: 0
        },
        {
          month: "Julio",
          Jul_target: 0,
          Jul_getter: 0
        },
        {
          month: "Agosto",
          Ago_target: 0,
          Ago_getter: 0
        },
        {
          month: "Septiembre",
          Sep_target: 0,
          Sep_getter: 0
        },
        {
          month: "Octubre",
          Oct_target: 0,
          Oct_getter: 0
        },
        {
          month: "Noviembre",
          Nov_target: 0,
          Nov_getter: 0
        },
        {
          month: "Diciembre",
          Dec_target: 0,
          Dec_getter: 0
        }
      ],
      kpiTypes: [
        {
          Id: 1,
          Description: "MANUAL",
          Meaning: "La meta y el valor serán introducidos manualmente."
        },
        {
          Id: 2,
          Description: "SEMI-AUTOMÁTICO",
          Meaning: "La meta se introduce manual y el valor será automático."
        },
        {
          Id: 3,
          Description: "FULL-AUTOMÁTICO",
          Meaning: "La meta y el valor serán automáticos."
        }
      ],
      // >> ORIGINAL DATA DETALLE KPI
      originalFormula: null,
      originalTypeId: 0,

      //TABLA DE SELECCIÓN DE FÓRMULA
      kpiFormulaLoading: false,
      showKpiFormulaDialog: false,
      selectedFormula: null,
      kpiFormulaList: [],
      kpiFormulaColumns: [
        {
          prop: "Id",
          label: "ID",
          width: 50
        },
        {
          prop: "Name",
          label: "Fórmula"
        },
        {
          prop: "Description",
          label: "Descripción"
        }
      ],

      disableGoal: true,
      disableValue: true,
      //DETAIL COLUMN EDITABLE
      detailColumns: [
        {
          prop: "month",
          label: "Mes"
        },
        {
          prop: "goal",
          label: "Meta",
          formatter: InputFormatter,
          attrs: {
            inputValue: "goal",
            disabled: this.isGoalDisable
          }
        },
        {
          prop: "value",
          label: "Valor",
          formatter: InputFormatter,
          attrs: {
            inputValue: "value",
            disabled: this.isValueDisable
          }
        }
      ],

      //ELIMINAR KPI-GERENCIA
      showDeleteDialog: false,
      deleteDepartmentOrKPI: ""
    };
  },
  created() {
    this.loadingTable = true;
    this.getDirections(); //Se consigue primero a las direcciones/gerencias para luego traer solo los KPI de esa dirección/gerencia.
    this.getDeparments();
    this.getResponsable();
    this.getData();
  },
  methods: {
    formatArrayToElSelect,
    arrayGet,

    //METODOS TABLA PRINCIPAL
    getData() {
      this.handleKpiBeforeClose();
      this.loadingTable = true;
      this.$http
        .get(
          `/api/kpis/TableReport?Year=${this.year}&company=${this.currentCompany}`,
          {
            timeout: 3 * 60 * 1000
          }
        )
        .then((response) => {
          //console.log("response KPI: ", response);
          let count = 1000;
          response.data.Rows.forEach((resp) => {
            resp.countID = count++;
            isNaN(resp.January) ? 0 : Number(resp.January);
            isNaN(resp.February) ? 0 : Number(resp.February);
            isNaN(resp.March) ? 0 : Number(resp.March);
            isNaN(resp.April) ? 0 : Number(resp.April);
            isNaN(resp.May) ? 0 : Number(resp.May);
            isNaN(resp.June) ? 0 : Number(resp.June);
            isNaN(resp.July) ? 0 : Number(resp.July);
            isNaN(resp.August) ? 0 : Number(resp.August);
            isNaN(resp.September) ? 0 : Number(resp.September);
            isNaN(resp.October) ? 0 : Number(resp.October);
            isNaN(resp.November) ? 0 : Number(resp.November);
            isNaN(resp.December) ? 0 : Number(resp.December);
          });
          //console.log("response KPI2: ", response);

          this.tableData = response.data.Rows;
          this.ApplyChildren(this.tableData);
          //this.handleDirectionChange(this.directionName);
        })
        .catch((error) => {
          console.error(error);
          this.loadingTable = false;
        });
    },

    tableRowClassName({ row }) {
      //console.log("Row: ", row);
      if (row.KpiId == 0) {
        return "department-row";
      }
      if (row.countID < 100) {
        return "directions";
      }
      if (row.countID >= 100 && row.countID < 300) {
        return "departments";
      }
      if (row.countID >= 300 && row.countID < 1000) {
        return "responsibles";
      }
    },

    //METODOS AGREGAR NUEVA GERENCIA
    AddNewGerencia() {
      if (this.currentUser.IsSupervisor) {
        this.showAddGerencia = true;
      } else {
        this.$message({
          type: "info",
          message: "Solo los supervisores pueden crear renglones."
        });
      }
    },

    addDirection() {
      this.checkAddGerencyForm();
      this.buttonLoading = true;
      this.$http
        .post("/api/kpis/AddMaster", {
          CreatedBy: this.currentUser.EmployeeId,
          DireccionId: this.directionId,
          ResponsableId: this.directionResponsable,
          CompanyCode: this.currentCompany,
          Name: this.createDirectionName,
          Year: this.year
        })
        .then(() => {
          this.buttonLoading = false;
          this.handleBeforeClose();
          this.getData();
        });
    },
    checkAddGerencyForm: function (e) {
      if (this.employeeId && this.createDirectionName) {
        return true;
      } else if (!this.createDirectionName && !this.employeeId) {
        this.$message({
          message: "Los campos de Direccion y de Responsable son requeridos",
          center: true,
          type: "error",
          showClose: true
        });
      } else if (!this.createDirectionName) {
        this.$message({
          message: "El campo de Direccion es requerido",
          center: true,
          type: "error",
          showClose: true
        });
      } else if (!this.employeeId) {
        this.$message({
          message: "El campo de Responsable es requerido",
          center: true,
          type: "error",
          showClose: true
        });
      }
      e.preventDefault();
    },

    //METODOS DE FILTROS
    async handleYearChange(year) {
      this.year = year;
      this.componentKey++;
      this.getDirections(); //Se consigue primero a las direcciones/gerencias para luego traer solo los KPI de esa dirección/gerencia.
      this.getDeparments();
      this.getResponsable();
      await this.getData();
      this.$refs.rabbeTable3.$forceUpdate();
      /*
      
      this.$refs.rabbeTable3.ExpandColumnTreeWith = 100;
      
      this.$refs.rabbeTable3.$forceUpdate();
      this.$forceUpdate();
      */
    },

    handleDirectionChange(direction) {
      this.loadingTable = true;
      if (direction) {
        this.filteredTableData = [];
        let filterByRenglonId = 0;
        this.showAllData = false;
        if (direction) {
          this.tableData.forEach((kpi) => {
            if (kpi.Name == direction.Name) {
              filterByRenglonId = kpi.RenglonKpiID;
              this.filteredTableData.push(kpi);
              this.ApplyChildren(this.filteredTableData);
            } else {
              if (kpi.RenglonKpiID == filterByRenglonId && this.isCEO) {
                this.filteredTableData.push(kpi);
                this.ApplyChildren(this.filteredTableData);
              } else if (
                kpi.RenglonKpiID == filterByRenglonId &&
                (kpi.Responsable.Id == this.currentUser.EmployeeId ||
                  kpi.Responsable.SuperVisorID == this.currentUser.EmployeeId)
              ) {
                this.filteredTableData.push(kpi);
                this.ApplyChildren(this.filteredTableData);
              }
            }
          });
        }
      } else {
        this.showAllData = true;
      }
      //console.log("FilterDataTable: ", this.filteredTableData);
    },

    // >> [~]
    /*
    handleResponsableFilter(responsable) {
      //console.log("RESPONSABLE: ", responsable);
    },
    */

    //ACTIONS
    handlePushAction(action) {
      switch (action.command) {
        case "show-kpi": {
          this.disableEdit = true;
          this.kpiMasterId = action.row.RenglonKpiID;
          this.kpiName = action.row.Name;
          this.kpiId = action.row.KpiId;
          this.disableGoal = true;
          this.disableValue = true;
          this.getDataToEdit();
          break;
        }
        case "add-kpi": {
          this.disableEdit = false;
          this.kpiMasterId = action.row.RenglonKpiID;
          this.kpiDepartment = action.row.Name;
          this.showAddKpi = true;
          this.disableGoal = false;
          this.disableValue = false;
          this.getEmployees();
          break;
        }
        case "delete-department": {
          this.kpiMasterId = action.row.RenglonKpiID;
          this.deleteDepartmentOrKPI = "delete-department";
          this.showDeleteDialog = true;
          break;
        }
        case "edit-kpi": {
          this.disableEdit = false;
          this.kpiMasterId = action.row.RenglonKpiID;
          this.kpiName = action.row.Name;
          this.kpiId = action.row.KpiId;
          this.kpiDirection = action.row.DirectionKpi;
          if (this.currentUser.IsSupervisor) {
            this.disableGoal = false;
            this.disableValue = false;
          } else {
            this.disableGoal = true;
            this.disableValue = false;
          }
          this.getDataToEdit();
          break;
        }
        case "delete-kpi": {
          this.kpiMasterId = action.row.RenglonKpiID;
          this.directionId = action.row.KpiId;
          this.deleteDepartmentOrKPI = "delete-kpi";
          this.showDeleteDialog = true;
          break;
        }
        case "update-kpi": {
          this.kpiId = action.row.KpiId;
          this.executeFormula();
          this.getData();
          break;
        }
      }
    },

    //METODOS DEL DETALLE DE KPI
    getDataToEdit() {
      /* Este request retorna todas las propiedades del Master Child (o KPI) dentro de una gerencia
       Llas cuales se usan para obtener todas las metas y valores del KPI. Los nombres de estas propiedades
       son exactamente iguales al arreglo [this.detailData] para que se guarden los datos en su propiedad
       correspondiente. [!] EN CASO DE QUE LOS NOMBRES CAMBIEN YA SEA EN EL CLIENTE O API HABRÁ UN ERROR [!] */
      this.$http
        .get(`/api/kpis/GetMasterChildData?childId=${this.kpiId}`)
        .then((response) => {
          let responseData = response.data;
          this.detailData.forEach((row) => {
            //Aqui se van llenando el arreglo [this.detailData] según los "nombres" (keys) de cada propiedad del [response] sean iguales a los del arreglo.
            let rowKeys = Object.keys(row);
            row[rowKeys[1]] = responseData[rowKeys[1]];
            row[rowKeys[2]] = responseData[rowKeys[2]];
          });
          this.responsableKpi = response.data.ResponsableID;
          this.kpiType = response.data.Type;
          this.selectedFormula = {
            Id: response.data.FormulaId,
            Name: response.data.FormulaName
          };
          this.originalFormula = this.selectedFormula;
          this.originalTypeId = response.data.Type;
          this.getEmployees();
          this.showAddKpi = true;
        });
    },
    CheckDetalleKPIForm: function (e) {
      if (this.responsableKpi && this.kpiName) {
        return true;
      } else if (!this.responsableKpi && !this.kpiName) {
        this.$message({
          message:
            "Los campos de Responsable y de Nombre del KPI son requeridos",
          center: true,
          type: "error",
          showClose: true
        });
      } else if (!this.responsableKpi) {
        this.$message({
          message: "El campo de Responsable es requerido",
          center: true,
          type: "error",
          showClose: true
        });
      } else if (!this.kpiName) {
        this.$message({
          message: "El campo de Nombre del KPI es requerido",
          center: true,
          type: "error",
          showClose: true
        });
      }
      e.preventDefault();
    },
    handleKpiDetailSave() {
      this.CheckDetalleKPIForm();
      let kpiMasterChild = {
        CreatedAt: new Date(),
        CurrentKpiMasterID: this.kpiMasterId,
        ResponsableID: this.responsableKpi,
        Name: this.kpiName,
        Id: this.kpiId,
        Type: this.kpiType,
        FormulaId: this.selectedFormula ? this.selectedFormula.Id : null
      };
      this.detailData.forEach((row) => {
        Object.assign(kpiMasterChild, row);
      });
      this.saveBtnLoading = true;
      if (this.kpiId > 0) {
        this.$http
          .post("/api/kpis/EditMasterChild", kpiMasterChild)
          .then(() => {
            this.showAddKpi = false;
            if (this.selectedFormula.Id && this.selectedFormula.Name) {
              //Si la formula y el Id son existem, entonces ejecútala.
              this.executeFormula();
            }
            this.getData();
            this.saveBtnLoading = false;
            this.$message({
              type: "success",
              message: "KPI Editado Existosamente"
            });
          });
      } else {
        this.$http.post("/api/kpis/AddMasterChild", kpiMasterChild).then(() => {
          this.showAddKpi = false;
          this.getData();
          this.saveBtnLoading = false;
        });
      }
    },
    handleChangeFormula() {
      this.showKpiFormulaDialog = true;
      if (this.kpiFormulaList.length <= 0) {
        this.handleKpiTypeChange(this.kpiType);
      }
    },

    // >> FORMULAS DE KPI
    handleKpiTypeChange(selectedKpiType) {
      if (selectedKpiType > 1) {
        this.kpiFormulaLoading = true;
        this.showKpiFormulaDialog = true;
        this.$http
          .get(
            `/api/kpis/GetAllFormulas?kpiType=${this.kpiType}&kpiDirection=${this.kpiDirection}`
          )
          .then((response) => {
            this.kpiFormulaList = response.data;
            this.kpiFormulaLoading = false;
          });
      } else {
        this.selectedFormula = null;
      }
    },
    handleCloseKpiFormulaDialog() {
      /*En caso de que el KPI ya tenga una formula asignada y se trata de editarla pero
      se cierra el drawer sin elegir una formula, entonces coloca los valores originales.
      y en caso de no tener una formula asignada forza el KPI a manual.*/
      if (this.originalTypeId && this.originalFormula) {
        this.kpiType = this.originalTypeId;
        this.selectedFormula = this.originalFormula;
      } else {
        this.kpiType = 1;
        this.selectedFormula = {};
      }
      this.showKpiFormulaDialog = false;
      this.kpiFormulaList = [];
    },
    handleSelectedFormula(selectedRow) {
      if (selectedRow) {
        this.selectedFormula = selectedRow;
        this.showKpiFormulaDialog = false;
      }
    },

    async executeFormula() {
      this.$http
        .get(`/api/kpis/ExecuteFormula?kpiId=${this.kpiId}`)
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    },

    // >> MANEJO DEL DISABLE EN LOS INPUT DE LA META Y EL VALOR
    isGoalDisable() {
      return this.disableGoal;
    },
    isValueDisable() {
      return this.disableValue;
    },

    // >> DELETE KPI
    deleteDepartmentOrKpi() {
      if (this.deleteDepartmentOrKPI == "delete-department") {
        this.$http
          .delete("/api/kpis/DeleteMaster", {
            data: {
              KpiId: this.kpiMasterId,
              CompanyCode: this.currentCompany
            }
          })
          .then(() => {
            this.closeDeleteDialog();
            this.getData();
          })
          .catch(() => {
            this.$message({
              type: "error",
              message: "Error al eliminar Departamento"
            });
          });
      } else if (this.deleteDepartmentOrKPI == "delete-kpi") {
        this.$http
          .delete("/api/kpis/DeleteMasterChild", {
            data: {
              ChildId: this.directionId,
              KpiId: this.kpiMasterId
            }
          })
          .then(() => {
            this.closeDeleteDialog();
            this.getData();
          })
          .catch(() => {
            this.$message({
              type: "error",
              message: "Error al eliminar KPI"
            });
          });
      }
    },

    //HELPERS
    async getDirections() {
      this.loadingTable = true;
      await this.$http
        .get("/api/Directions/DirectionsByCompany", {
          params: {
            company: this.currentCompany
          }
        })
        .then((response) => {
          let count = 1;
          response.data.forEach((resp) => {
            resp.countID = count++;
          });

          //console.log("Direction: ", response);
          this.directionsChild = response.data;
          //  //console.log("curenuser : ", this.currentUser);
          this.directions = this.formatArrayToElSelect(response.data);
          //console.log("Direction2: ", this.directions);

          if (this.currentUser.UserID != 10) {
            //Si el usuario es diferente de 10 (UserID = 10 es Don Arturo) entonces NO filtres por gerencia y trae todo.
            this.directionName = this.directions.find(
              (direction) => direction.Id == this.currentUser.DireccionID
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    async getDeparments() {
      await this.$http
        .get("/api/deparments/GetDepartmentbyCompany", {
          params: { companyID: this.currentCompany }
        })
        .then((deparments) => {
          let count = 100;
          deparments.data.forEach((resp) => {
            resp.countID = count++;
          });
          //console.log("Departments :", deparments);
          this.departmentsChild = deparments.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    async getResponsable() {
      await this.$http
        .get(`/api/Employees/GetEmployeesByCompany`, {
          params: { companyID: this.currentCompany }
        })
        .then((response) => {
          let count = 300;
          response.data.forEach((resp) => {
            resp.countID = count++;
          });
          const subordinates = response.data;
          //console.log("Employees: ", subordinates);
          this.EmployeesChild = subordinates;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    ///*
    async ApplyChildren(DataTable) {
      //let directionsChildData = {};

      /*
      this.directionsChild.forEach(direction => {
        //console.log("direction: ", direction);
        
        
        direction.children = DataTable.filter(
          dataTable => dataTable.DirectionKpi === direction.Id

        );
      });
      */

      ///*
      await this.directionsChild.forEach((direction) => {
        //console.log("direction: ", direction);

        direction.children = this.departmentsChild.filter(
          (department) => department.DirecctionID === direction.Id
        );
      });
      await this.directionsChild.forEach((direction) => {
        //let self = this;
        direction.children.forEach((department) => {
          department.children = this.EmployeesChild.filter(
            (employee) => employee.DeparmentId === department.Id
          );
        });
      });

      await this.directionsChild.forEach((direction) => {
        direction.children.forEach((department) => {
          department.children.forEach((employee) => {
            employee.children = DataTable.filter((dataTable) =>
              dataTable.Responsable
                ? dataTable.Responsable.Id === employee.Id
                : false
            );
            //console.log(employee.Name, " ", employee.children)
            employee.January = this.CalculateMonthKPI(
              employee.children,
              "January"
            );
            employee.February = this.CalculateMonthKPI(
              employee.children,
              "February"
            );
            employee.March = this.CalculateMonthKPI(employee.children, "March");
            employee.April = this.CalculateMonthKPI(employee.children, "April");
            employee.May = this.CalculateMonthKPI(employee.children, "May");
            employee.June = this.CalculateMonthKPI(employee.children, "June");
            employee.July = this.CalculateMonthKPI(employee.children, "July");
            employee.August = this.CalculateMonthKPI(
              employee.children,
              "August"
            );
            employee.September = this.CalculateMonthKPI(
              employee.children,
              "September"
            );
            employee.October = this.CalculateMonthKPI(
              employee.children,
              "October"
            );
            employee.November = this.CalculateMonthKPI(
              employee.children,
              "November"
            );
            employee.December = this.CalculateMonthKPI(
              employee.children,
              "December"
            );
          });
          //console.log(department.Name, " ", department.children)
          department.January = this.CalculateMonthKPI(
            department.children,
            "January"
          );
          department.February = this.CalculateMonthKPI(
            department.children,
            "February"
          );
          department.March = this.CalculateMonthKPI(
            department.children,
            "March"
          );
          department.April = this.CalculateMonthKPI(
            department.children,
            "April"
          );
          department.May = this.CalculateMonthKPI(department.children, "May");
          department.June = this.CalculateMonthKPI(department.children, "June");
          department.July = this.CalculateMonthKPI(department.children, "July");
          department.August = this.CalculateMonthKPI(
            department.children,
            "August"
          );
          department.September = this.CalculateMonthKPI(
            department.children,
            "September"
          );
          department.October = this.CalculateMonthKPI(
            department.children,
            "October"
          );
          department.November = this.CalculateMonthKPI(
            department.children,
            "November"
          );
          department.December = this.CalculateMonthKPI(
            department.children,
            "December"
          );
        });
        //console.log(direction.Name, " ", direction.children)
        direction.January = this.CalculateMonthKPI(
          direction.children,
          "January"
        );
        direction.February = this.CalculateMonthKPI(
          direction.children,
          "February"
        );
        direction.March = this.CalculateMonthKPI(direction.children, "March");
        direction.April = this.CalculateMonthKPI(direction.children, "April");
        direction.May = this.CalculateMonthKPI(direction.children, "May");
        direction.June = this.CalculateMonthKPI(direction.children, "June");
        direction.July = this.CalculateMonthKPI(direction.children, "July");
        direction.August = this.CalculateMonthKPI(direction.children, "August");
        direction.September = this.CalculateMonthKPI(
          direction.children,
          "September"
        );
        direction.October = this.CalculateMonthKPI(
          direction.children,
          "October"
        );
        direction.November = this.CalculateMonthKPI(
          direction.children,
          "November"
        );
        direction.December = this.CalculateMonthKPI(
          direction.children,
          "December"
        );
      });

      //*/
      //console.log("directionsChild: ", this.directionsChild);
      this.Childs = this.directionsChild;
      this.loadingTable = false;
      /*
              department.children= this.EmployeesChild.filter(
                employee => employee.Id === department.SuperVisorID
              )
              */
    },
    CalculateMonthKPI(kpis, month) {
      //console.log("kpis: ", kpis);
      let MonthKpiSum = 0;
      let qty = 0;

      kpis.forEach((kpi) => {
        MonthKpiSum += Number(kpi[month]) ? Number(kpi[month]) : 0;
        qty++;
      });

      //console.log(MonthKpiSum, " " , qty, kpis );
      MonthKpiSum /= qty;
      //console.log("Type: ",typeof  typeof MonthKpiSum, " ", typeof NaN)
      MonthKpiSum = isNaN(MonthKpiSum) ? 0 : MonthKpiSum;

      return MonthKpiSum.toFixed(2);
    },
    //*/
    getEmployees(directionId) {
      this.responsableLoading = true;
      this.$http
        .get(
          `/api/Employees/GetEmployeeByCriteria?DepartmentID=${this.deparmentId}&DirectionID=${directionId}`
        )
        .then((response) => {
          this.responsableLoading = false;
          const subordinates = response.data;
          //console.log("subordinates: ", subordinates);
          this.directionEmployees = subordinates;
        });
    },
    handleNewDirectionChange(direction) {
      this.createDirectionName = direction.Name;
      this.directionId = direction.Id;
      this.getEmployees(direction.Id);
    },
    handleChangeEmployee(employee) {
      this.directionResponsable = employee;
    },

    //CLEANERS
    handleBeforeClose() {
      this.createDirectionName = "";
      this.directionId = "";
      this.employeeId = "";
      this.responsableKpi = "";
      this.directionEmployees = [];
      this.showAddGerencia = false;
    },
    handleKpiBeforeClose() {
      this.showAddKpi = false;
      this.kpiName = "";
      this.kpiMasterId = 0;
      this.kpiId = 0;
      this.kpiType = 1;
      this.selectedFormula = {};
      this.responsableKpi = "";
      this.detailData = [
        {
          month: "Enero",
          Jan_target: 0,
          Jan_getter: 0
        },
        {
          month: "Febrero",
          Feb_target: 0,
          Feb_getter: 0
        },
        {
          month: "Marzo",
          Mar_target: 0,
          Mar_getter: 0
        },
        {
          month: "Abril",
          Abr_target: 0,
          Abr_getter: 0
        },
        {
          month: "Mayo",
          May_target: 0,
          May_getter: 0
        },
        {
          month: "Junio",
          Jun_target: 0,
          Jun_getter: 0
        },
        {
          month: "Julio",
          Jul_target: 0,
          Jul_getter: 0
        },
        {
          month: "Agosto",
          Ago_target: 0,
          Ago_getter: 0
        },
        {
          month: "Septiembre",
          Sep_target: 0,
          Sep_getter: 0
        },
        {
          month: "Octubre",
          Oct_target: 0,
          Oct_getter: 0
        },
        {
          month: "Noviembre",
          Nov_target: 0,
          Nov_getter: 0
        },
        {
          month: "Diciembre",
          Dec_target: 0,
          Dec_getter: 0
        }
      ];
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
      this.deleteDepartmentOrKPI = "";
      this.kpiMasterId = 0;
      this.kpiId = 0;
      this.kpiDirection = 0;
      this.directionId = 0;
      this.kpiName = "";
    }
  },
  computed: {
    getDeleteDialogTitle() {
      if (this.deleteDepartmentOrKPI == "delete-department") {
        return "ELIMINAR GERENCIA";
      } else if (this.deleteDepartmentOrKPI == "delete-kpi") {
        return "ELIMINAR KPI";
      } else {
        return "";
      }
    },
    getDetailData() {
      if (this.detailDataEdit.length > 0) {
        return this.detailDataEdit;
      } else {
        return this.detailData;
      }
    },
    getTotalofItems() {
      return this.tableData.length;
    },
    isCEO() {
      return this.currentUser.Roles.some((kpi) => kpi.Name == "CEO");
    },
    yearsForFilter() {
      const lowLevel = 2020;
      const currentYear = new Date().getFullYear() + 1; // [!] Se le supa uno para que contemple 1 año en el futuro;
      let Years = [];
      for (var i = lowLevel; i <= currentYear; i++) {
        Years.push({ label: i, value: i });
      }
      return Years;
    }
  },

  watch: {
    kpiType(type) {
      /* El [kpiType] guarda el tipo de KPI:
        1 = Manual            -> Meta y Valor son proporcionadas por el usuario.
        2 = Semi-Automático   -> La Meta la proporciona el usuario y Valor es automático mediante query.
        3 = Full-Automático   -> Meta y Valor automáticos mdiante query.
      Según el valor de [kpiType] se van activar o desactivas los inputs de la tabla del dialog [Detalle de KPI].
    */
      switch (type) {
        case 1: {
          this.disableGoal = false;
          this.disableValue = false;
          break;
        }
        case 2: {
          this.disableGoal = false;
          this.disableValue = true;
          break;
        }
        case 3: {
          this.disableGoal = true;
          this.disableValue = true;
          break;
        }
      }
    }
  }
};
</script>
<style>
.el-table .department-row {
  background: #3a93ce;
  color: white;
  font-weight: bold;
}
.directions {
  color: rgba(11, 73, 232, 0.974);
  font-weight: bold;
}
.departments {
  color: rgba(11, 185, 248, 0.816);
  font-weight: bold;
}
.responsibles {
  font-weight: bold;
}
</style>
